import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

import Home from '@/components/Home/Home.vue';
import Communications from '@/components/Communications.vue';
import Confirm from '@/components/Confirm.vue';
import Contact from '@/components/Contact.vue';
import Done from '@/components/Done.vue';
import IsResident from '@/components/IsResident.vue';
import Questions from '@/components/Questions/Questions.vue';
import Question from '@/components/Questions/Question.vue';
import Ownership from '@/components/Ownership/Ownership.vue';
import ProxyHolder from '@/components/ProxyHolder/ProxyHolder.vue';
import Review from '@/components/Review/Review.vue';

const router = new Router({
  mode: 'history',
  base: __dirname,
  scrollBehavior: (to, from, savedPosition) => {
    // Only force scroll to top if hitting nav buttons on page, NOT
    // browser's native back/forward buttons
    if (savedPosition) {
      return;
    }

    // Hack to force scroll to top due to MDL hijacking the page
    const top = document.getElementById('app-layout');
    if (!top) {
      return;
    }
    return top.scrollTo(0, 0);
  },
  routes: [
    {name: 'home', path: '/', component: Home},
    {name: 'ownership', path: '/ownership', component: Ownership},
    {name: 'contact', path: '/contact', component: Contact},
    {name: 'isresident', path: '/isresident', component: IsResident},
    {
      name: 'questions',
      path: '/questions',
      component: Questions,
      children: [{name: 'question', path: ':questionId', component: Question}]
    },
    {name: 'proxy', path: '/proxy', component: ProxyHolder},
    {name: 'comms', path: '/comms', component: Communications},
    {name: 'review', path: '/review', component: Review},
    {name: 'confirm', path: '/confirm', component: Confirm},
    {name: 'done', path: '/done', component: Done},

    // Catch-all for invalid routes
    {path: '*', redirect: '/'}
  ]
});

export default router;
